export const mortgageQueryKeys = {
  _base: () => ["mortgage"],
  all: (agencyId: string) => [...mortgageQueryKeys._base(), { agencyId }],
  single: (agencyId: string, mortgageId: string) => [
    ...mortgageQueryKeys.all(agencyId),
    "single",
    { mortgageId },
  ],
  byPerson: (agencyId: string, personId?: string) => [
    ...mortgageQueryKeys.all(agencyId),
    "byPerson",
    { personId },
  ],
};
